/**
 * Template service for API calls
 */
import api from './api';
import { Template, TemplateCreate, TemplateUpdate } from '../types/template';

export const templateService = {
    /**
     * Get all templates
     */
    async getAllTemplates(): Promise<Template[]> {
        const response = await api.get('/templates');
        return response.data;
    },

    /**
     * Get a single template by ID
     */
    async getTemplateById(id: string): Promise<Template> {
        const response = await api.get(`/templates/${id}`);
        return response.data;
    },

    /**
     * Create a new template
     */
    async createTemplate(data: TemplateCreate): Promise<Template> {
        const response = await api.post('/templates', data);
        return response.data;
    },

    /**
     * Update a template
     */
    async updateTemplate(id: string, data: TemplateUpdate): Promise<Template> {
        const response = await api.put(`/templates/${id}`, data);
        return response.data;
    },

    /**
     * Delete a template
     */
    async deleteTemplate(id: string): Promise<void> {
        await api.delete(`/templates/${id}`);
    },

    /**
     * Reset a system template to its canonical default content
     */
    async resetTemplate(id: string): Promise<Template> {
        const response = await api.post(`/templates/${id}/reset`);
        return response.data;
    },
};
